t = require('app/scripts/views/internal/teacup-with-helpers')('board_observer_count')

module.exports = ->
  t.a '.quiet-button.js-show-observers', { href: '#', style: 'margin: 4px 0 0;' }, ->
    t.text t.mustacheVar('localizedObserverCount')
